import { useSearchParams } from 'react-router-dom'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { formatCurrency } from '@/lib/utils'

export const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams()
  const dataParam = searchParams.get('data')

  let paymentData: any = null
  try {
    if (dataParam) {
      paymentData = JSON.parse(decodeURIComponent(dataParam))
    }
  } catch (err) {
    console.error('Failed to parse payment data:', err)
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-2xl">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
            <svg
              className="h-6 w-6 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <CardTitle className="text-2xl font-bold text-gray-900">Payment Successful!</CardTitle>
          <CardDescription>Your payment has been processed successfully.</CardDescription>
        </CardHeader>
        {paymentData && (
          <CardContent className="space-y-4">
            <div className="rounded-lg bg-gray-50 p-4">
              <h3 className="mb-3 text-sm font-semibold text-gray-700">Payment Details</h3>
              <div className="space-y-2">
                {paymentData.sessionId && (
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Session ID:</span>
                    <span className="text-sm font-medium text-gray-900">{paymentData.sessionId}</span>
                  </div>
                )}
                {paymentData.transactionId && (
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Transaction ID:</span>
                    <span className="text-sm font-medium text-gray-900">{paymentData.transactionId}</span>
                  </div>
                )}
                {paymentData.status && (
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Status:</span>
                    <Badge variant="default" className="bg-green-600">
                      {paymentData.status}
                    </Badge>
                  </div>
                )}
                {paymentData.amount && paymentData.currency && (
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Amount:</span>
                    <span className="text-sm font-medium text-gray-900">
                      {formatCurrency(paymentData.amount / 100, paymentData.currency)}
                    </span>
                  </div>
                )}
              </div>
            </div>
            {/* Display all additional data */}
            {Object.keys(paymentData).length > 0 && (
              <details className="rounded-lg bg-gray-50 p-4">
                <summary className="cursor-pointer text-sm font-semibold text-gray-700">View Full Response</summary>
                <pre className="mt-3 overflow-auto text-xs text-gray-600">{JSON.stringify(paymentData, null, 2)}</pre>
              </details>
            )}
          </CardContent>
        )}
      </Card>
    </div>
  )
}
